import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import i18n from '../../../../utils/i18n.js';
import '../../../icon/icon.js';
import style from './author-teaser.css';

/**
 * @property {string} name
 * @property {string} description
 * @property {string} imageLink
 * @property {string} imageAltText
 * @property {string} pageLink
 * @property {string} linkedInPageLink
 */
export default class AuthorTeaser extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            name: '',
            description: '',
            imageLink: '',
            imageAltText: '',
            pageLink: '',
            linkedInPageLink: '',
        };
    }

    template() {
        return html`
            <div class="container">
                <img src="${this.imageLink}" class="image" alt="${this.imageAltText}" />
                <div>
                    <div class="flex flex-row gap-8 items-baseline">
                        <h2 class="name">${this.name}</h2>
                        ${when(
                            this.linkedInPageLink,
                            html`
                                <a
                                    href="${this.linkedInPageLink}"
                                    class="linked-in rounded-full bg-white p-2 h-40 w-40"
                                >
                                    <mb-icon name="social--linkedin"></mb-icon>
                                </a>
                            `,
                        )}
                    </div>
                    <p class="description mb-40">${this.description}</p>
                    <a href="${this.pageLink}" class="btn btn-outline-primary "
                        >${i18n('authorTeasers.showArticles')}</a
                    >
                    <a href="${this.pageLink}" class="btn btn-link">${i18n('authorTeasers.showArticles')}</a>
                </div>
            </div>
        `;
    }
}

defineElement('mb-author-teaser', AuthorTeaser);
